import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

import { ROUTES } from '../routes/paths';

/**
 * Rendered when a route element or loader throws.
 *
 * Only a generic description is shown. The underlying error may reference
 * internal paths or identifiers, so it is never rendered into the page.
 */
export function RouteErrorPage() {
  const error = useRouteError();

  const heading = isRouteErrorResponse(error)
    ? `${String(error.status)} ${error.statusText}`
    : 'Something went wrong';

  return (
    <div role="alert">
      <h1>{heading}</h1>
      <p>
        We could not display this page. Please try again, and contact support if the problem
        continues.
      </p>
      <p>
        <Link to={ROUTES.home}>Return to the home page</Link>
      </p>
    </div>
  );
}
